<template>
  <v-container fluid>
    <router-view></router-view>
  </v-container>
</template>
<script>
import reportService from "@/modules/Reports/service.js"

const REPORTS = {
  "payment-summary": { key: "payments.summary", name: "Payments", category: "Financial" },
  daySummary: { key: "sales.day-summary", name: "Sale Summary", category: "Sales" },
  monthlyTaxes: { key: "taxes.monthly", name: "Monthly Taxes", category: "Financial" },
  quaterlyTaxes: { key: "taxes.quarterly", name: "Quarterly Taxes", category: "Financial" },
  "customer-list": { key: "customers.list", name: "Customer List", category: "Customer" },
  "sale-summary": { key: "sales.location-summary", name: "Location Sales Summary", category: "Sales" },
  "serialized-inventory": { key: "inventory.serialized", name: "Serialized Inventory", category: "Inventory" },
}

export default {
  name: "report-view",
  watch: {
    "$route.fullPath": {
      immediate: true,
      handler() {
        if (!/^\/reportview\//i.test(this.$route.path)) return
        const report = REPORTS[this.$route.name]
        if (!report) return
        const query = this.$route.query || {}
        reportService.Usage.recordOpen({
          reportKey: report.key,
          reportName: report.name,
          route: this.$route.fullPath,
          filters: {
            dateFrom: query.start || undefined,
            dateTo: query.end || undefined,
            preset: query.range || undefined,
            category: report.category,
          },
          LocationId:
            this.$route.params.id ||
            query.LocationId ||
            query.locationId ||
            undefined,
        })
      },
    },
  },
}
</script>
